import { render, staticRenderFns } from "./T1TripInfoWidget.vue?vue&type=template&id=20e2d814&scoped=true&"
import script from "./T1TripInfoWidget.vue?vue&type=script&lang=js&"
export * from "./T1TripInfoWidget.vue?vue&type=script&lang=js&"
import style0 from "./T1TripInfoWidget.vue?vue&type=style&index=0&id=20e2d814&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e2d814",
  null
  
)

export default component.exports